module.exports = do ->
   React = require("react")
   _ = require("underscore").default
   {createFactory} = require("base/new-utils")
   Property = require("entities/search/query-parts/property-query")
   CommentMixin = require("mixins/comment-mixin")
   ThankViewInteractions = createFactory(require("apps/interactions/components/interaction-thankview").default)
   dompurify = require('dompurify')

   # Converts interaction HTML bodies to plain text for users without the RTE flag.
   # Sanitized HTML from the backend can contain (a) encoded entities like `&#39;`
   # from Jsoup serialization and (b) block-level tags (<p>, <div>, <br>) whose
   # structure carries the line breaks of a templated email. stripHtml alone
   # leaves both untouched, so we route through the browser's parser: textContent
   # decodes entities and we inject \n for block elements so `white-space: pre-line`
   # on .interaction--text renders the original formatting.
   htmlToPlainText = (input) ->
      return input unless input
      # Fast path: no tags and no entities — nothing to do. Skips the DOMPurify
      # parse that would otherwise run on every interaction row render.
      return input unless /[<&]/.test(input)

      # Entities only, no tags: decode via <textarea> (much cheaper than dompurify).
      if input.indexOf('<') < 0
         textarea = document.createElement('textarea')
         textarea.innerHTML = input
         return textarea.value

      # Has HTML: sanitize first so innerHTML assignment below is safe, then walk
      # the DOM to turn block-level structure into newline-separated plain text.
      cleanHtml = dompurify.sanitize(input)
      div = document.createElement('div')
      div.innerHTML = cleanHtml
      div.querySelectorAll('br').forEach((br) -> br.replaceWith(document.createTextNode('\n')))
      div.querySelectorAll('p, div, li, tr, h1, h2, h3, h4, h5, h6, blockquote, pre')
         .forEach((el) -> el.appendChild(document.createTextNode('\n')))
      # Leading/trailing newlines from block-level wrappers aren't meaningful content;
      # interior newlines (including blank lines between paragraphs) are preserved.
      div.textContent.replace(/^\n+|\n+$/g, '')

   InteractionUtils =
      getHighlightRegex: (query_string) ->
         if _.isArray(query_string) then words = query_string
         else words = query_string?.split?(" ") || []
         _.compact(_.map(words, (word) ->
            trimmed_word = word?.toLowerCase()?.trim()
            if !_.isEmpty(trimmed_word)
               _.regexEscape(trimmed_word)
         )).join("|")

      getPropertiesForCategoryQuery: (categories) ->
         [ Property("interaction_type.untouched", categories, {type: "contains"}) ]

      renderSummary: (summary, showRichText) ->
         if summary
            if showRichText
               cleanHtml = dompurify.sanitize(summary)
               React.createElement('div', { dangerouslySetInnerHTML: { __html: cleanHtml } })
            else
               summary

      # Add the ... to the beginning and end of the text if it's in the middle of the comment
      # Slice the text / show the text snippet unless @props.showFullText is set

      renderText: (interaction, showFullText, limit, showRichText) ->
         if showFullText
            if showRichText
               cleanHtml = dompurify.sanitize(interaction?.text || '')
               React.createElement('div', { dangerouslySetInnerHTML: { __html: cleanHtml } })
            else
               htmlToPlainText(interaction?.text)
         else if interaction.interaction_type == "ThankView - Video" && window.location.pathname == "/contact/*"
            ThankViewInteractions
               interaction: interaction
         else if interaction.interaction_type == "ThankView - Video" && window.location.pathname == "/interaction/*"
            parts = interaction.text.split("\r\n\r\n\r\n\r\n")
            message = parts[0]
            CommentMixin.getSnippet(message, 200)

         else
            if _.isEmpty(interaction?._highlight)
               if interaction.interaction_type == "EverTrue Comment"
                  CommentMixin.getSnippet(interaction.text, 200)
               else if interaction.interaction_type == "ThankView - Video" && window.location.pathname == "/interaction/*"
                  parts = interaction.text.split("\r\n\r\n\r\n\r\n")
                  message = parts[0]
                  CommentMixin.getSnippet(message, message.length)
               else if interaction.interaction_type == "ThankView - Video" && window.location.pathname == "/contact/*"
                  ThankViewInteractions
                     interaction: interaction
               else
                  textContent = htmlToPlainText(interaction?.text) || ""
                  textContent.substr(0, 200) + (if textContent.length > 200 then "..." else "")
            else
               highlights = interaction?._highlight?.text
               limit = limit || highlights?.length

               start_highlight = _.first(highlights)
               highlight_index = interaction?.text?.indexOf?(start_highlight)

               prefix = if highlight_index == 0 then "" else "..."
               suffix = if highlight_index + start_highlight.length < interaction?.text?.length then "..." else ""
               prefix + _.first(highlights, limit)?.join("...") + suffix

   InteractionUtils
